<template>
    <span data-testid="mention-text">
        <template :key="segmentKey(segment, index)" v-for="(segment, index) in segments">
            <span v-html="autolinkText(segment.value)" v-if="segment.type === 'text'" />
            <a
                :href="segment.href"
                class="font-medium text-blue-500"
                data-testid="mention-link"
                v-else-if="segment.href"
            >
                @{{ segment.label }}
            </a>
            <span class="font-medium text-gray-400" data-testid="mention-disabled" v-else>
                @{{ segment.label }}
            </span>
        </template>
    </span>
</template>

<script setup lang="ts">
    import autolinker from 'autolinker';
    import { computed } from 'vue';
    import { parseMentions, type ContentSegment } from '@/utils/parseMentions.ts';

    interface Props {
        content: string;
    }

    const props = defineProps<Props>();

    const segments = computed(() => parseMentions(props.content));

    const autolinkText = (value: string): string =>
        autolinker.link(value, {
            sanitizeHtml: true,
        });

    // Segments come from an immutable parse and never reorder, but derive a
    // stable key from the segment content so the key isn't a bare index.
    const segmentKey = (segment: ContentSegment, index: number): string => {
        const value =
            segment.type === 'text' ? segment.value : `${segment.entityType}:${segment.label}`;
        return `${index}:${segment.type}:${value}`;
    };
</script>
